import { SessionStorage } from 'common/CookieStorage'
import { STORAGEKEYS } from 'enviroment/Keys'
import { HelpersService } from 'service/HelpersService/HelpersService'
import { PostalCodeModel } from 'service/HelpersService/HelpersServiceProps'
import { ILocationsModels } from './OnBlurHandlersProps'

export const getLocationsByPostalCodeOnBlur = async(postalCode: string) => {
   if(postalCode.trim().replace('-', '').length === 5) {
      const helpersService = new HelpersService()
      const result = await helpersService.getLocationByPostalCode(postalCode)
      const sessionStorage = new SessionStorage()
      
      const mappedLocations: ILocationsModels[] = result.map((location: PostalCodeModel) => {
         return {
            city: location.city,
            streets: location.streets
         }
      })
      
      sessionStorage.add(STORAGEKEYS.LOCATIONS, JSON.stringify(mappedLocations))
   }
}

export const saveCityToSessionStorageOnBlur = (cityNameFromField: string) => {
   const sessionStorage = new SessionStorage()

   if(cityNameFromField.length > 0){
      sessionStorage.add(STORAGEKEYS.CURRENT_CITY_VALUE, cityNameFromField)
   }
   else {
      sessionStorage.add(STORAGEKEYS.CURRENT_CITY_VALUE, '')
   }
}